'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dFeatures$0024 from "./presto.types$-Features$.js";
var $p;
/** @constructor */
function $c_Lpresto_ListDirectivesPage(id, global) {
  this.tI = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$L0;
  this.wX = false;
  this.tI = id;
  this.wX = global;
}
export { $c_Lpresto_ListDirectivesPage as $c_Lpresto_ListDirectivesPage };
$p = $c_Lpresto_ListDirectivesPage.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_ListDirectivesPage;
/** @constructor */
function $h_Lpresto_ListDirectivesPage() {
}
export { $h_Lpresto_ListDirectivesPage as $h_Lpresto_ListDirectivesPage };
$h_Lpresto_ListDirectivesPage.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__hashCode__I("ListDirectivesPage"));
  var $x_2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$();
  var $x_1 = acc;
  var t = this.tI;
  acc = $x_2.o($x_1, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_RTLong(t.e, t.f)));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, (this.wX ? 1231 : 1237));
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().ai(acc, 2);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_ListDirectivesPage)) {
    if ((this.wX === x$0.wX)) {
      var this$1 = this.tI;
      var b = x$0.tI;
      return ((this$1.e === b.e) && (this$1.f === b.f));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 2;
});
$p.s = (function() {
  return "ListDirectivesPage";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.tI;
  }
  if ((n === 1)) {
    return this.wX;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.dl = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some($j_presto$002etypes$0024$002dFeatures$0024.$m_Lpresto_types$Features$().qe);
});
function $isArrayOf_Lpresto_ListDirectivesPage(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iG)));
}
export { $isArrayOf_Lpresto_ListDirectivesPage as $isArrayOf_Lpresto_ListDirectivesPage };
var $d_Lpresto_ListDirectivesPage = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_ListDirectivesPage, "presto.ListDirectivesPage", ({
  iG: 1,
  a2: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_ListDirectivesPage as $d_Lpresto_ListDirectivesPage };
//# sourceMappingURL=presto.-List-Directives-Page.js.map
